module.exports = class Destination {
  constructor(name, description, phone, homepage, address, holidays, parking, admissionFee, folderName) {
    this.name = name || undefined;
    this.description = description || undefined;
    this.phone = phone || undefined;
    this.homepage = homepage || undefined;
    this.address = address || undefined;
    this.holidays = holidays || undefined;
    this.parking = parking || undefined; //true or false
    this.admissionFee = admissionFee || undefined; //number
    this.folderName = folderName || undefined;
  }
}
